var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FieldContainer',{attrs:{"label":_vm.label,"required":_vm.required,"readOnly":_vm.readOnly,"error":_vm.error,"hintHtml":_vm.hintHtml}},[_c('b-form-datepicker',{attrs:{"value":_vm.value,"readonly":_vm.readOnly,"disabled":_vm.isDisabled},on:{"input":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }